// Modified Assets.js
import React, { useState, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import SettingsNavBar from './SettingsNavBar';
import Account from './Account';
import Sites from './Sites';
function Settings({ editEnabled }) {
  const { theme } = useTheme();
  const [settingsCurrentSelection, setSettingsCurrentSelection] = useState('account');

  const handleSettingsNavigate = (selection) => {
    setSettingsCurrentSelection(selection);
  };

  return (
      <div className="h-[calc(100vh-4px)] w-screen overflow-hidden relative">
        <div className="flex h-full pt-16">
          <SettingsNavBar 
            onNavigate={handleSettingsNavigate} 
            currentSelection={settingsCurrentSelection} 
          />
          {settingsCurrentSelection === 'account' && <Account editEnabled={editEnabled} />}
          {settingsCurrentSelection === 'sites' && <Sites editEnabled={editEnabled} />}
        </div>
      </div>
  );
}

export default Settings;